import { Component } from '@angular/core'
import { Auth } from '../../../injectable'

@Component({
    selector: 'app-cross-origin-verification',
    template: ''
})
export class CrossOriginVerificationComponent {

    constructor(private _auth0: Auth) {
        _auth0.auth?.crossOriginVerification()
    }
}
